import { Site } from "../../../lib/src/api/partner/models/Site";
import { FC } from "react";
import { Paragraph } from "../../../lib/src/components/Paragraph";
import { ModalFooter } from "../../../lib/src/components/layout/ModalProvider";
import { useApiClient } from "../../../lib/src/api";
import { config } from "../config";
import { useRefresh } from "../../../lib/src/components/RefreshController";
import { useRealtimeDeployments } from "../components/deployments/RealtimeDeployments";

export const CancelDeletionModal: FC<{ site: Site }> = ({ site }) => {
  const { partnerClient } = useApiClient(config)
  const { awaitNextDeploymentFinished } = useRealtimeDeployments()!
  const refresh = useRefresh()
  const done = async () => {
    const deployment = await partnerClient.cancelSiteDeletion(site.id)
    if (deployment.success) {
      await awaitNextDeploymentFinished(deployment.data.id)
    }
    refresh()
    close()
  }
  return <>
    <div className={'space-x-4 flex-1'}>
      <Paragraph>The deletion of site (<strong>{site.displayName}</strong>) will be canceled. Continue?</Paragraph>
      <ModalFooter text={'Cancel deletion'} onSubmit={done} />
    </div>
  </>
}
